/* eslint-disable */
//styles
import "../../src/styles/App.css";
import Logo from "../styles/img/header.svg";

//Components
import Header from "../Components/Common/header";

//react
import { useEffect, useState } from "react";
import React from "react";

//redux
import { scanToken } from "../lib/slices/paladin";
import { store } from "../lib/store";

//hooks
import RoundLoader from "../Hooks/RoudLoader";
import { useCameraReady } from "../Hooks/useCameraReady";

//libs
import { datadogLogs } from "@datadog/browser-logs";
import { MdCancel } from "react-icons/md";
import toast from "react-hot-toast";
import { Toaster } from "react-hot-toast";

//Components
import InvitationFail from "../Components/InvitationFail";
import CameraGate from "../Components/Common/CameraGate";

//Utils
import { isVerifiedMobileDevice } from "../Utils/deviceValidation";

//Results
import Success from "../Components/Results/Success.js";

//constants
import { ALERTS_STYLES, ALERTS_POSITION_SELFIE } from "../constants/alerts.js";

const Capture = () => {
  const [loading, setLoading] = useState(false);
  const { dispatch } = store;
  const cameraReady = useCameraReady({ component: "Capture" });
  const urlSearchParams = new URLSearchParams(window.location.search);
  const token = urlSearchParams.get("token");
  const [tenantColor, setTenantColor] = useState(localStorage.getItem(`tenantColor_${token}`) || "#6A2ABD");
  const [tenantImage, setTenantImage] = useState(Logo);
  const [tenantName, setTenantName] = useState("FraudFighter");
  const [view, setView] = useState("default");
  const [responseScan, setResponseScan] = useState(null);
  const [previewCapture, setPreviewCapture] = useState(null);
  const [previewUpload, setPreviewUpload] = useState(null);
  const [fileName, setFileName] = useState("");
  const [finalFile, setFinalFile] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [textTitle, setTextTitle] = useState("");
  const [textLoading, setTextLoading] = useState("");
  const [redirect, setRedirect] = useState(false);

  const resetFileState = () => {
    setFinalFile(null);
    setPreviewCapture(null);
    setPreviewUpload(null);
    setFileName("");
  };

  const isValidFile = (file) => {
    if (!file) return false;

    const isImage = file.type.startsWith("image/");
    const isPdf = file.type === "application/pdf";

    return isImage || isPdf;
  };

  const handleCapture = (event) => {
    const file = event?.target?.files[0];

    if (file && file?.type?.startsWith("image/")) {
      const imageUrl = URL?.createObjectURL(file);
      setFinalFile(file);
      setPreviewCapture(imageUrl);
      setView("capture");
    } else {
      toast.error("Only image files are allowed for capture");
      resetFileState();
      event.target.value = "";
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setFileName(file.name);
    setFinalFile(file);
    setView("upload");

    if (file.type.startsWith("image/")) {
      const imageUrl = URL.createObjectURL(file);
      setPreviewUpload(imageUrl);
    } else {
      setPreviewUpload(null);
    }
  };


  const queryData = async () => {
    setLoading(true);
    setTextLoading("");
    setTextTitle("");
    var data = { token };

    try {
      const response = await dispatch(scanToken({ data }));
      const resolvedColor = response?.payload?.ScanToken?.custom_color || "#6A2ABD";
      setTenantColor(resolvedColor);
      localStorage.setItem(`tenantColor_${token}`, resolvedColor);
      setTenantImage(
        response?.payload?.ScanToken?.custom_image &&
        `data:image/jpeg;base64,${response?.payload?.ScanToken?.custom_image}`,
      );
      setTenantName(
        response?.payload?.ScanToken?.account_name
          ? response?.payload?.ScanToken?.account_name
          : "",
      );
      setResponseScan(response?.payload?.ScanToken);
      datadogLogs.logger.log(
        `Token validated (App) with invitation ${response?.payload?.ScanToken?.invitation_id}`,
        {
          category: "token-validation",
          status: "info",
          tenantName: response?.payload?.ScanToken?.account_name,
          invitationId: response?.payload?.ScanToken?.invitation_id,
          token: token,
        },
      );
    } catch (error) {
      datadogLogs.logger.log("Error validating token (App) - additional data", {
        category: "error",
        status: "info",
        token: token,
        errorMessage: error?.message,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    queryData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const uploadFile = async () => {

    if (!isValidFile(finalFile)) {
      toast.error("Only image or PDF files are allowed");
      resetFileState();
      return;
    }

    const accessToken = token;

    const url = `${process.env.REACT_APP_PALIDIN_ENDPOINT_DEV}v1/web/upload?accessToken=${accessToken}`;

    const formData = new FormData();
    formData.append("file", finalFile);

    setLoading(true);
    setTextLoading("Uploading file...");
    setTextTitle("Please wait");

    try {
      const res = await fetch(url, {
        method: "POST",
        body: formData,
      });

      const data = await res.text();
      if (res?.ok) {
        setIsSuccess(true);
        setRedirect(res?.redirected);
      } else {
        toast.error(`Error uploading file: Invalid document format.`);
        resetFileState();
        event.target.value = "";
        datadogLogs.logger.error(
          `Error uploading file (App) - additional data with invitation ${responseScan?.invitation_id}`,
          {
            category: "error",
            status: "info",
            token: token,
            invitationId: responseScan?.invitation_id,
            errorMessage: data,
            response: res
          },
        );
      }
      React.createElement(Success, {
        token: token,
        responseScan: responseScan,
        tenantName: tenantName,
        tenantColor: tenantColor,
        tenantImage: tenantImage,
      });
      datadogLogs.logger.log(
        `File uploaded (App) - additional data with invitation ${responseScan?.invitation_id}`,
        {
          category: "file-upload",
          status: "info",
          token: token,
          invitationId: responseScan?.invitation_id,
          responseMessage: data,
        },
      );
    } catch (err) {
      datadogLogs.logger.log(
        `Error uploading file (App) - additional data with invitation ${responseScan?.invitation_id}`,
        {
          category: "error",
          status: "info",
          token: token,
          invitationId: responseScan?.invitation_id,
          errorMessage: err,
        },
      );
      toast.error(`Error uploading file: ${err?.message}`);
      resetFileState();
      event.target.value = "";
    } finally {
      setLoading(false);
      setTextLoading("");
      setTextTitle("");
    }
  };

  return (
    <>
      <main className="w-full min-h-screen flex flex-col">
        {loading ? (
          <div className="flex flex-col gap-8 h-screen items-center justify-center w-full container mx-auto p-3 py-6">
            <RoundLoader
              loading={loading}
              color={tenantColor}
              title={textTitle}
              textLoading={textLoading}
            />
          </div>
        ) : (
          <>
            {responseScan?.invitation_id && (
              <>
                {isVerifiedMobileDevice() ? (
                  <CameraGate tenantColor={tenantColor} responseScan={responseScan}>
                  <div className="flex flex-col gap-8 items-center justify-start p-3 pt-9 bg-white flex-1 lg:hidden`">
                    {isSuccess ? (
                      <Success
                        token={token}
                        responseScan={responseScan}
                        tenantName={tenantName}
                        tenantColor={tenantColor}
                        tenantImage={tenantImage}
                        redirect={redirect}
                      />
                    ) : (
                      <>
                        <Header
                          tenantImage={tenantImage}
                          tenantName={tenantName}
                        />
                        {view === "default" && (
                          <section className="flex flex-col gap-4 items-center justify-center w-full container mx-auto p-5 py-8 pb-9">
                            <h2 className="text-2xl text-center my-3">
                              Upload a document
                            </h2>
                            <p className="text-sm text-center m-0 p-0">
                              You’re being asked to verify your identity by
                              providing a document. To continue, you can either
                              capture a photo of your document or upload an
                              existing file. This helps ensure your security and
                              protects against identity fraud.
                            </p>
                            <p className="text-sm text-center mt-6">
                              Select one of the following options:
                            </p>

                            <input
                              type="file"
                              accept="image/*,application/pdf"
                              capture="environment"
                              id="cameraInput"
                              style={{ display: "none" }}
                              onChange={handleCapture}
                            />

                            <button
                              className="shadow-md mt-2 mb-2 rounded-full uppercase w-2/3 py-2.5 disabled:opacity-50 disabled:cursor-not-allowed"
                              style={{ backgroundColor: tenantColor }}
                              onClick={() =>
                                document.getElementById("cameraInput").click()
                              }
                              disabled={!cameraReady}
                            >
                              Capture
                            </button>

                            <p className="text-sm text-center m-0 p-0">OR</p>

                            <input
                              type="file"
                              id="uploadFile"
                              style={{ display: "none" }}
                              onChange={handleFileChange}
                            />

                            <button
                              className="shadow-md mt-2 mb-2 rounded-full uppercase w-2/3 py-2.5"
                              style={{ backgroundColor: tenantColor }}
                              onClick={() =>
                                document.getElementById("uploadFile").click()
                              }
                            >
                              Upload
                            </button>
                          </section>
                        )}

                        {view === "capture" && (
                          <div className="flex flex-col gap-3 w-48 items-center">
                            {previewCapture && (
                              <img
                                src={previewCapture}
                                alt="Captured preview"
                                className="w-full object-cover mt-4 rounded shadow-md"
                              />
                            )}

                            <div className="flex gap-2 w-full">
                              <button
                                className="bg-gray-300 text-gray-800 py-2 px-4 rounded-lg shadow-md hover:bg-gray-400 transition w-full"
                                onClick={() => {
                                  setView("default");
                                  setPreviewCapture(null);
                                }}
                              >
                                Back
                              </button>

                              <button
                                className="bg-gray-300 text-black-800 py-2 px-4 rounded-lg shadow-md hover:bg-gray-400 transition w-full"
                                style={{ backgroundColor: tenantColor }}
                                onClick={() => {
                                  uploadFile();
                                  setView("default");
                                }}
                              >
                                Upload
                              </button>
                            </div>
                          </div>
                        )}

                        {view === "upload" && (
                          <div className="flex flex-col gap-3 w-48 items-center">
                            <div className="flex flex-col items-center gap-4">
                              {previewUpload && (
                                <img
                                  src={previewUpload}
                                  alt="Upload preview"
                                  className="w-full object-cover mt-4 rounded shadow-md"
                                />
                              )}
                              {fileName && (
                                <p
                                  style={{
                                    color: "#6A2ABD",
                                    border: "2px solid purple",
                                    borderRadius: "10px",
                                    padding: "10px",
                                    display: "inline-block",
                                  }}
                                >
                                  {fileName}
                                </p>
                              )}
                            </div>

                            <div className="flex gap-2 w-full">
                              <button
                                className="bg-gray-300 text-gray-800 py-2 px-4 rounded-lg shadow-md hover:bg-gray-400 transition w-full"
                                onClick={() => {
                                  setView("default");
                                  setPreviewUpload(null);
                                }}
                              >
                                Back
                              </button>

                              <button
                                className="bg-gray-300 text-black-800 py-2 px-4 rounded-lg shadow-md hover:bg-gray-400 transition w-full"
                                style={{ backgroundColor: tenantColor }}
                                onClick={() => {
                                  uploadFile();
                                  setView("default");
                                }}
                              >
                                Upload
                              </button>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                  </CameraGate>
                ) : (
                  <div className="flex justify-center items-center min-h-screen flex-col gap-3 container px-3 py-5 bg-[#F8F7F6] w-full">
                    <MdCancel size={150} className="text-[#E43122]" />
                    <h2 className="text-2xl text-[#E43122]">Error</h2>
                    <p className="my-5 text-center text-sm">
                      PALIDIN WebID is not available for desktop computers.{" "}
                      <br></br>
                      Please open the authentication invitation on a mobile
                      device.
                    </p>
                  </div>
                )}
              </>
            )}
            {(responseScan?.error || token === null) && <InvitationFail />}
          </>
        )}

        <Toaster
          position={ALERTS_POSITION_SELFIE}
          reverseOrder={false}
          toastOptions={ALERTS_STYLES}
        />
      </main>
    </>
  );
};

export default Capture;
